// extracted by mini-css-extract-plugin
export default {"container":"speacialities-banner_container__LbBrX","SpecialitiesBanner":"speacialities-banner_SpecialitiesBanner__zJXlg"};